import { useNotificationsContext } from '../contexts/NotificationContext';

export const useNotifications = () => useNotificationsContext();

export default useNotifications;